export enum MailTemplateAutotext {
    Date,
    Time,
    SaleDate,
    IssueDate,
    PaymentSum,
    ClientName,
    Signature,
    Signatures,
    Currency,
    CompanyName,
    CurrentUserName,
    CurrentUserSurname,
    BankAccount,
    BankAccountName,
    BankAccountBankName,
    BankAccountPln,
    BankAccountPlnName,
    BankAccountPlnBankName,
    Arrearage,
    AccountingFilename,
    AccountingFileKind,
    AccountingDateRange
}
